export default "__VITE_ASSET__e4e3e902__"